interface IntegrationPartnerDialogState {
  isVisible: boolean
  status: 'success' | 'error'
  error?: string
  integrationPartner?: string
}

const state = reactive<IntegrationPartnerDialogState>({
  isVisible: false,
  status: 'success',
  error: undefined,
  integrationPartner: undefined,
})

export function useIntegrationPartnerDialog() {
  function showDialog(status: 'success' | 'error', error?: string, integrationPartner?: string) {
    state.isVisible = true
    state.status = status
    state.error = error
    state.integrationPartner = integrationPartner
  }

  function hideDialog() {
    state.isVisible = false
    state.status = 'success'
    state.error = undefined
    state.integrationPartner = undefined
  }

  return {
    ...toRefs(state),
    showDialog,
    hideDialog,
  }
}
